import template from './index.pug'

export default Vue.extend({
  name: 'cookies-policy-text-page',
  template: template(),
  created() {
    window.scrollTo(0, 0)
  }
})